import { Component } from '@angular/core';
import moment from 'moment';
import { ApiService } from '../../../web-services/api/api.service';
import { UtilService } from '../../../services/util.service';
import { TranslatorService } from '../../../services/translator_service';
import { ApiQuery } from '../../../web-services/api/api.query';
import { ResponsiveService } from '../../../services/responsive.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { RTLDivDirectiveDirective } from '../../../directives/rtldiv-directive.directive';
import { MatDividerModule } from '@angular/material/divider';
import { BinLiveStatus } from '../../bin-live-status/bin-live-status';
import { BinEvents } from '../bin-events/bin-events';
import { BinCapacity } from '../bin-capacity/bin-capacity';
import { BinCollectionHistory } from '../bin-collection-history/bin-collection-history';
import { BinCollectionPie } from '../bin-collection-pie/bin-collection-pie';
import { BinInfo } from '../bin-info/bin-info';
import { BinTicketsList } from '../bin-tickets-list/bin-tickets-list';
import { BinLocationDescription } from '../bin-location-description/bin-location-description';
import { ApiStore } from '../../../web-services/api/api.store';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-bin-live-info-page',
  imports: [CommonModule,TranslatePipe,RTLDivDirectiveDirective,MatDividerModule,BinLiveStatus,BinEvents,
    BinCapacity,BinCollectionHistory,BinCollectionPie,BinInfo,
	BinTicketsList,BinLocationDescription],  
  templateUrl: './bin-live-info-page.html',
  styleUrl: './bin-live-info-page.scss',
})
export class BinLiveInfoPage {
  isMobile: Boolean;
	landscape:boolean=true;
	showLocation:boolean;
	showEvents:boolean;
	routeParamsSub;
	bin: any = null;
	binId;
	currentLang;
	translationsObj;
	usageType = 1;
	user_role_id = 0;
	bin_type_id = -1;
	original_bin_type_id = -1;
	enableActiveQuickSamplingPlan = false;
	activateClick = false;
	stopClick = false;
	constructor(private translator: TranslatorService, private utilService: UtilService, private router: Router,
		private apiQuery:ApiQuery,private apiStore:ApiStore,
		private responsiveService: ResponsiveService,private apiService:ApiService,
		private route: ActivatedRoute) {
			this.translator.currentLangEmitter$
			.subscribe(async value=>{						
			  this.translationsObj = await this.translator.getTranslation(value).toPromise()			 
			  this.currentLang = value;
			})
	}

	ngOnInit() {
		this.onResize();
		this.responsiveService.checkWidth();
		this.routeParamsSub = this.route
			.queryParams
			.subscribe(params => {
				this.binId = params['binId'] || null;				
				setTimeout(() => {
					this.apiService.getBinInfo(this.binId);
				}, 0);
			});

		this.apiQuery.binInfo$.subscribe((info) => {
			if (info == null || parseInt(this.binId) != info.bin_id) {
				return;
			}
			this.bin = info;
			this.bin_type_id = this.bin.bin_type_id;			
			this.original_bin_type_id = this.bin.bin_type_for_reset;
			this.activateClick = false;
			this.stopClick = false;
			if(this.bin_type_id == 10){
				this.enableActiveQuickSamplingPlan = false;
			}else{
				this.enableActiveQuickSamplingPlan = true;
			}
		});
		this.apiQuery.user$.subscribe(user => {
			if (!user) return;
			if(user["usage_type_id"] != 1){
				this.usageType = user["usage_type_id"];
			}
			this.user_role_id = user["user_role_id"];
		});
	}

	rangeBtnEventHander($event: any) {
		this.landscape = $event;
	}

	onResize() {
		this.responsiveService.getMobileStatus().subscribe(isMobile => {
		  this.isMobile = isMobile;
		});
	}

	ngOnDestroy() {
		this.routeParamsSub.unsubscribe();
	}

	showLocationEventHandler($event: any) {
		this.showLocation = $event;		
	  }

	showEventHandler($event: any) {
		this.showEvents = $event;		
	}

	navigateTo = (navigateTo: string) => {
		this.router.navigate(['/' + navigateTo]);
	}

	activateQuickSamplingPlan() {
		if(this.activateClick){
			return;
		}
		this.activateClick = true;
		const dataToSend = {
			"bin_type" : "10",
			"num_of_hours_for_bin_type_reset" : 1,
			"bin_id_list" : [[Number(this.bin.bin_id),Number(this.bin.cluster_id)]]			
		};
		this.apiService.setBinThresholdsAndRestrictions(dataToSend).subscribe((v:any) => {
			this.apiService.getBinInfo(this.binId);
			this.apiService.getfilteredBinsInfo(JSON.parse(sessionStorage.getItem("chosenSites")));
			this.apiStore.update({ allFilteredBasicBins: [] });                    
			this.apiStore.update({ filteredBasicBins: [] }); 
			this.apiService.getfilteredBasicBinsInfo(JSON.parse(sessionStorage.getItem("chosenSites")));
		});
	}

	stopQuickSamplingPlan() {
		if(this.stopClick){
			return;
		}
		this.stopClick = true;
		const dataToSend = {
			"bin_type" : this.original_bin_type_id,
			"num_of_hours_for_bin_type_reset" : 0,
			"bin_id_list" : [[Number(this.bin.bin_id),Number(this.bin.cluster_id)]]			
		};
		this.apiService.setBinThresholdsAndRestrictions(dataToSend).subscribe((v:any) => {
			this.apiService.getBinInfo(this.binId);
			this.apiService.getfilteredBinsInfo(JSON.parse(sessionStorage.getItem("chosenSites")));
			this.apiStore.update({ allFilteredBasicBins: [] });                    
			this.apiStore.update({ filteredBasicBins: [] }); 
			this.apiService.getfilteredBasicBinsInfo(JSON.parse(sessionStorage.getItem("chosenSites")));
		});
	}

	calcDiff = (date: string) => {
		if (this.translationsObj != undefined) {
			let diff_in_string = '';
			const original_date = moment(date);
			const date_time_now = moment();
			const diff_in_object: any = this.utilService.preciseDiffBetweenDates(original_date, date_time_now, true);
			if (diff_in_object.months > 0) {
				diff_in_string = diff_in_string + diff_in_object.months + ' ';
				if (diff_in_object.months === 1) {
					diff_in_string += this.translationsObj.COLLECTION_REPORT.MONTH + ' ';
				} else {
					diff_in_string += this.translationsObj.COLLECTION_REPORT.MONTHS + ' ';
				}
			}
			if (diff_in_object.days > 0) {
				diff_in_string = diff_in_string + diff_in_object.days + ' ';
				if (diff_in_object.days === 1) {
					diff_in_string += this.translationsObj.COLLECTION_REPORT.DAY + ' ';
				} else {
					diff_in_string += this.translationsObj.COLLECTION_REPORT.DAYS + ' ';
				}
			}
			if (diff_in_object.hours > 0) {
				if (diff_in_object.days > 0) {
					diff_in_string += this.translationsObj.COLLECTION_REPORT.AND + ' ' + diff_in_object.hours + ' ';
				} else {
					diff_in_string += diff_in_object.hours + ' ';
				}
				if (diff_in_object.hours === 1) {
					diff_in_string += this.translationsObj.COLLECTION_REPORT.HOUR + ' ';
				} else {
					diff_in_string += this.translationsObj.COLLECTION_REPORT.HOURS + ' ';
				}
			}
			
			if (diff_in_object.minutes > 0) {
				if (diff_in_object.hours > 0) {
					diff_in_string += this.translationsObj.COLLECTION_REPORT.AND + ' ' + diff_in_object.minutes + ' ';
				} else {
					diff_in_string += diff_in_object.minutes + ' ';
				}
				if (diff_in_object.minutes === 1) {
					diff_in_string += this.translationsObj.COLLECTION_REPORT.MINUTE + ' ';
				} else {
					diff_in_string += this.translationsObj.COLLECTION_REPORT.MINUTES + ' ';
				}
			}
			else {
				diff_in_string += this.translationsObj.COLLECTION_REPORT.MINUTE + ' ';
			}

			if (this.currentLang !== 'iw') {
				diff_in_string += this.translationsObj.COLLECTION_REPORT.AGO;
			}
			else {
				diff_in_string = this.translationsObj.COLLECTION_REPORT.AGO + ' ' + diff_in_string;
			}
			return diff_in_string;
		}	
	}
}
